import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M68.4299 47.1899L62.1999 1.31995H8.12988L1.8999 47.1899C1.8999 47.1899 11.8899 66.9599 35.0099 56.0599C56.3199 65.8099 68.4299 47.1899 68.4299 47.1899Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
